$('.btn.edit-address').click(function() {
  $(this).hide();
  $(this).parents('td').siblings('.address-edit').show();
  $(this).siblings('.btn.edit-address-cancel').show();
  $(this).siblings('.btn.edit-address-submit').show();
  $(this).siblings('.btn.delete-address').hide();
  $(this).parents('td').siblings('.address-record').hide()
});

$('.btn.edit-address-submit').click(function() {
  $(this).hide();
  $(this).parents('td').siblings('.address-edit').hide();
  $(this).siblings('.btn.edit-address-cancel').hide();
  $(this).siblings('.btn.edit-address').show();
  $(this).siblings('.btn.delete-address').show();
  $(this).parents('td').siblings('.address-record').show()
});

$('.btn.edit-address-cancel').click(function() {
  $(this).hide();
  $(this).parents('td').siblings('.address-edit').hide();
  $(this).siblings('.btn.edit-address-submit').hide();
  $(this).siblings('.btn.edit-address').show();
  $(this).siblings('.btn.delete-address').show();
  $(this).parents('td').siblings('.address-record').show()
});

// $('.carousel').carousel()

// $('.single-product-images').slick({
//   slidesToShow: 1,
//   slidesToScroll: 1,
//   customPaging : function(slider, i) {
//     var thumb = $(slider.$slides[i]).data('thumb');
//     return `<a><img class="img-fluid" src=${thumb} /></a>`;
//   },
//   responsive: [
//     {
//       breakpoint: 1024,
//       settings: {
//         slidesToShow: 3,
//         slidesToScroll: 3,
//         infinite: true,
//         dots: true
//       }
//     },
//     {
//       breakpoint: 600,
//       settings: {
//         slidesToShow: 2,
//         slidesToScroll: 2
//       }
//     },
//     {
//       breakpoint: 480,
//       settings: {
//         slidesToShow: 1,
//         slidesToScroll: 1
//       }
//     }
//   ]
// });

function getVariantFromOptions() {
  let variantArr = []
  $(".product-category select").map(function(i, el) {
    variant = {value: $(el).val(), index: $(el).data('index')};
    variantArr.push(variant)
  });
  return variantArr;
}

function updateHistoryState(variant) {
  if (!history.replaceState || !variant) {
    return;
  }

  var newurl =
    window.location.protocol +
    '//' +
    window.location.host +
    window.location.pathname +
    '?variant=' +
    variant.id;
  
  window.history.replaceState({ path: newurl }, '', newurl);
}

$('.product-category select').on('change', function() {
  var selectedValues = getVariantFromOptions();
  var variants = window.product.variants;
  
  // Search for product variants based on what was selected in the dropdowns
  var found = _.find(variants, function(variant) {
    return selectedValues.every(function(values) {
      return _.isEqual(variant[values.index], values.value);
    });
  });
  updateHistoryState(found)
  $('#variant-id').val(found.id)
});

/* dropdown */

// (function($){
// 	$("li:has(ul)").hover(function(){
// 	  $(this).find("ul").not(":animated").slideDown(0);
// 	}, function(){
// 	  $(this).find("ul").not(":animated").slideUp(0);
// 	});
//   })(jQuery);



/* drawer */
jQuery('.drawer-icon').on('click', function () {
	jQuery('.drawer').toggleClass('m_checked');
});

jQuery('.drawer-overlay').on('click', function () {
	jQuery('.drawer').toggleClass('m_checked');
});





jQuery(window).on('scroll', function ($) {
	if (100 < jQuery(this).scrollTop()) {
		jQuery('.floating').show();
	} else {
		jQuery('.floating').hide();
	}
});

jQuery(window).on('scroll', function ($) {
	var winW = $(window).width();
  	var devW = 768;
 	 if (winW <= devW){
		jQuery('.floating').hide();
	} else {
		jQuery('.floating').hide();
	}
});

/* SmoothScroll */
jQuery('a[href^="#"]').click(function () {
	var header = 0; // jQuery( '#header' ).height();
	var speed = 300;
	var id = jQuery(this).attr('href');
	var target = jQuery('#' == id ? 'html' : id);
	var position = jQuery(target).offset().top - header;
	if (0 > position) {
		position = 0;
	}
	jQuery('html, body').animate(
		{
			scrollTop: position
		},
		speed
	);
	return false;
});

var swiper = new Swiper('.swiper-container', {
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    loop: true,
    effect: 'fade',
    speed: 2500,
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true,
    },

    autoplay: {
    delay: 5000,
    disableOnInteraction: true
  },
  });

  // DatePicker
  $(document).ready( function() {
    $(function() {
      var holidays = ["2020-11-08","2020-11-15","2020-11-22","2020-11-29",];
      $("#date").datepicker( 
        {
        minDate: +2,
        maxDate: '+1M',
        showMonthAfterYear: true,
//         beforeShowDay: jQuery.datepicker.noWeekends
        beforeShowDay: function(date){
          var datestring = jQuery.datepicker.formatDate('yy-mm-dd', date);
          return [ holidays.indexOf(datestring) == -1 ]
        }
      } );
      $("#date").datepicker("setDate", new Date());
    });
  });

// コンタクトページでenterによる誤送信を無効化
  // document.getElementById("contact_form").onkeypress = (e) => {
  //   const key = e.keyCode || e.charCode || 0;
  //   if (key == 13) {
  //     e.preventDefault();
  //   }
  // }
